import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { languageHelper } from "../../../config/helperFunctions";

function Setting() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [showModal, setShowModal] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedLogo, setSelectedLogo] = useState("");
  const [selectedLoader, setSelectedLoader] = useState("");
  const [selectedSplash, setSelectedSplash] = useState("");
  const [loading, setLoading] = useState(false);
  const [colorId, setColorId] = useState(null);
  const [webColorId, setWebColorId] = useState();
  const [colors, setColors] = useState({
    type: "color_theme",
    color_1: "",
    color_2: "",
    color_3: "",
    color_4: "",
    color_5: "",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
  });
  const [webColors, setWebColors] = useState({
    type: "color_theme",
    color_1: "",
    color_2: "",
    color_3: "",
    color_4: "",
    color_5: "",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
  });
  const [restaurantId, setRestaurantId] = useState(null);
  const [restaurant, setRestaurant] = useState({
    restaurant_name: "",
    address: "",
    tax_reg_no: "",
    phone: "",
    whatsapp: "",
    tax_method: "",
    email: "",
    days: "",
    hours: "",
    start_time: "",
    end_time: "",
    is_zatca: "no",
  });
  const [themeId, setThemeId] = useState(null);
  const [theme, setTheme] = useState({
    theme: "",
  });
  const [invoiceId, setInvoiceId] = useState(null);
  const [invoice, setInvoice] = useState({
    invoice: "",
    invoice_lang: "",
    invoice_footer: "",
    invoice_footer1: "",
    invoice_footer2: "",
    order_date: "",
    statement_date: "",
    print_date: "",
    round_off: "",
    sale_date_time: "",
    no_of_invoices: "",
  });
  const [printId, setPrintId] = useState(null);
  const [printSetting, setPrintSetting] = useState({
    printing_type: "",
    jspm_print: "",
    android_version: "",
  });
  const [logoId, setLogoId] = useState(null);
  const [logoSetting, setLogoSetting] = useState({
    logo_image: "",
    logo_image_url: "",
  });
  const [logo, setLogo] = useState(null);
  const [logoUpload, setLogoUpload] = useState(null);
  const [loaderId, setLoaderId] = useState(null);
  const [loaderSetting, setLoaderSetting] = useState({
    loader: "",
    loader_url: "",
  });
  const [loader, setLoader] = useState(null);
  const [loaderUpload, setLoaderUpload] = useState(null);
  const [splashId, setSplashId] = useState(null);
  const [splashSetting, setSplashSetting] = useState({
    splash: "",
    splash_url: "",
  });
  const [splash, setSplash] = useState(null);
  const [splashUpload, setSplashUpload] = useState(null);

  const cherryRed = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#bf0303",
    color_2: "#000000",
    color_3: "#bf0303",
    color_4: "#ffffff",
    color_5: "#bf0303",
  };
  const sunLight = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#EBC400",
    color_2: "#000000",
    color_3: "#EBC400",
    color_4: "#ffffff",
    color_5: "#EBC400",
  };
  const aquaBlue = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#098398",
    color_2: "#000000",
    color_3: "#098398",
    color_4: "#ffffff",
    color_5: "#098398",
  };
  const lightGray = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#A0A1A6",
    color_2: "#000000",
    color_3: "#A0A1A6",
    color_4: "#ffffff",
    color_5: "#A0A1A6",
  };
  const lightPink = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#DD035A",
    color_2: "#000000",
    color_3: "#DD035A",
    color_4: "#ffffff",
    color_5: "#DD035A",
  };
  const darkGreen = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#074842",
    color_2: "#000000",
    color_3: "#074842",
    color_4: "#ffffff",
    color_5: "#074842",
  };
  const defaultColor = {
    type: "color_theme",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
    status: "enable",
    color_1: "#7B20C7",
    color_2: "#000000",
    color_3: "#7B20C7",
    color_4: "#ffffff",
    color_5: "#7B20C7",
  };

  const handleRestaurantSettingsChange = (e) => {
    setRestaurant((prevRestaurant) => ({
      ...prevRestaurant,
      [e.target.name]: e.target.value,
    }));
  };

  const handleInvoiceSettingsChange = (e) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePrintereSettingsChange = (e) => {
    setPrintSetting((prevPrint) => ({
      ...prevPrint,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePresetColor = (theme) => {
    setColors((prevColors) => ({
      ...prevColors,
      ...theme,
    }));
    setWebColors((prevColors) => ({
      ...prevColors,
      ...theme,
    }));
  };

  const handleColorChange = (e) => {
    setColors((prevColors) => ({
      ...prevColors,
      [e.target.name]: e.target.value,
    }));
  };
  const handleWebColorChange = (e) => {
    setWebColors((prevColors) => ({
      ...prevColors,
      [e.target.name]: e.target.value,
    }));
  };

  const handleColorUpdate = (e) => {
    setLoading(true);
    e.preventDefault();

    axios
      .put(
        `${apiKey}/api/rms/admin/settings/${colorId}`,
        {
          ...colors,
          type: "color_theme",
          user_id: user?.user.id,
          outlet_id: user?.user.outlet_id,
          status: "enable",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setShowModal(false);

        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
    axios
      .put(
        `${apiKey}/api/rms/admin/settings/${webColorId}`,
        {
          ...webColors,
          type: "web_color_theme",
          user_id: user?.user.id,
          outlet_id: user?.user.outlet_id,
          status: "enable",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setShowModal(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // console.log("Time", restaurant?.start_time, restaurant?.end_time);
  const handleUpdate = (e) => {
    setLoading(true);
    e.preventDefault();

    // Prepare JSON data for the settings
    const settingsData = [
      {
        ...restaurant,
        id: restaurantId,
        hours: restaurant?.start_time + " - " + restaurant?.end_time,
      },
      { ...invoice, id: invoiceId },
      { ...printSetting, id: printId },
      { ...theme, id: themeId },
    ];

    // API call to update settings
    const updateSettings = axios.post(
      `${apiKey}/api/rms/admin/settings-update`,
      { settings: settingsData },
      {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    // Prepare logo form data and API call for logo update if a logo exists
    let updateLogo = Promise.resolve(); // Default to resolved promise
    if (logo) {
      const formData = new FormData();
      formData.append("logo_image", logoUpload);

      updateLogo = axios.post(
        `${apiKey}/api/rms/admin/logo-update/${logoId}?_method=PUT`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    let loaderUpdate = Promise.resolve();
    if (loader) {
      const formData = new FormData();
      formData.append("loader", loaderUpload);

      loaderUpdate = axios.post(
        `${apiKey}/api/rms/admin/loader-update/${loaderId}?_method=PUT`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    let splashUpdate = Promise.resolve();
    if (splash) {
      const formData = new FormData();
      formData.append("splash", splashUpload);

      splashUpdate = axios.post(
        `${apiKey}/api/rms/admin/splash-update/${splashId}?_method=PUT`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    // Use Promise.all to wait for both API calls
    Promise.all([updateSettings, updateLogo, loaderUpdate, splashUpdate])
      .then((responses) => {
        // eslint-disable-next-line no-unused-vars
        const [settingsResponse, logoResponse, loaderResponse, splashResponse] =
          responses;
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        if (logo) {
          console.log("Logo updated:", logoResponse);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("overflow-y-hidden");
    } else {
      document.body.classList.remove("overflow-y-hidden");
    }
  }, [showModal]);

  useEffect(() => {
    const fetchSettings = () => {
      axios
        .get(`${apiKey}/api/rms/admin/settings`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          const colorItem = res.data.filter(
            (item) => item.type === "color_theme"
          )[0];
          setColors(JSON.parse(colorItem.value));
          setColorId(colorItem.id);
          const webColorItem = res.data.filter(
            (item) => item.type === "web_color_theme"
          )[0];
          // console.log(webColorItem);
          setWebColors(JSON.parse(webColorItem.value));
          // console.log("error");
          setWebColorId(webColorItem.id);
          // JSON.parse(
          const generalItem = res.data.filter(
            (item) => item.type === "general"
          )[0];

          if (generalItem) {
            setRestaurant(JSON.parse(generalItem.value));
            setRestaurantId(generalItem.id);
          }

          const themeItem = res.data.filter((item) => item.type === "theme")[0];
          if (themeItem) {
            setTheme(JSON.parse(themeItem.value));
            setThemeId(themeItem.id);
          }

          const invoiceItem = res.data.filter(
            (item) => item.type === "invoice_settings"
          )[0];
          if (invoiceItem) {
            setInvoice(JSON.parse(invoiceItem.value));
            setInvoiceId(invoiceItem.id);
          }

          const printSettingItem = res.data.filter(
            (item) => item.type === "printer_settings"
          )[0];
          if (printSettingItem) {
            setPrintSetting(JSON.parse(printSettingItem.value));
            setPrintId(printSettingItem.id);
          }

          const logoSettingItem = res.data.filter(
            (item) => item.type === "logo"
          )[0];

          if (logoSettingItem) {
            setLogoSetting(JSON.parse(logoSettingItem?.value));
            setLogoId(logoSettingItem?.id);
          }

          const loaderSettingItem = res.data.filter(
            (item) => item.type === "loader"
          )[0];

          if (loaderSettingItem) {
            setLoaderSetting(JSON.parse(loaderSettingItem?.value));
            setLoaderId(loaderSettingItem?.id);
          }

          const splashSettingItem = res.data.filter(
            (item) => item.type === "splash"
          )[0];

          if (splashSettingItem) {
            setSplashSetting(JSON.parse(splashSettingItem?.value));
            setSplashId(splashSettingItem?.id);
          }
          // setColors(JSON.parse(res.data.value));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setPageLoading(false);
        });
    };
    handleCSRF(fetchSettings);
  }, [user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Restaurant Setting")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleUpdate}>
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-x-8 gap-y-2 w-full ">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Restaurant Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Imdady RMS"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="restaurant_name"
                    value={restaurant?.restaurant_name}
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Address")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Riyadh"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="address"
                    value={restaurant?.address}
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2   font-bold">
                  {languageHelper("Tax Registration No")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="300395761900003"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={restaurant?.tax_reg_no}
                    name="tax_reg_no"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Phone")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="00000088979696"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    value={restaurant?.phone}
                    name="phone"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2   font-bold">
                  {languageHelper("Whatsapp Number")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="966535090666"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={restaurant?.whatsapp}
                    name="whatsapp"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Tax Method")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Tax method"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={restaurant?.tax_method}
                    name="tax_method"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Email")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="11223@gmail.com"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    value={restaurant?.email}
                    name="email"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2   font-bold">
                  {languageHelper("Days")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Saturday-Monday"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={restaurant?.days}
                    name="days"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Hours")}
                </span>
                <div className="mb-2 pt-0 flex gap-x-2">
                  <input
                    type="time"
                    placeholder="11:30 AM"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={restaurant?.start_time}
                    name="start_time"
                    onChange={handleRestaurantSettingsChange}
                  />
                  <input
                    type="time"
                    placeholder="12:00 AM"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    value={restaurant?.end_time}
                    name="end_time"
                    onChange={handleRestaurantSettingsChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Invoice")}
                </span>
                <div className="mb-2 pt-0">
                  {/* <input
                    type="text"
                    placeholder="Default"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    value={invoice.invoice}
                    
                  /> */}
                  <select
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="invoice"
                    onChange={handleInvoiceSettingsChange}
                  >
                    <option
                      selected={invoice.invoice === "Default"}
                      value="Default"
                    >
                      {languageHelper("Default")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 1"}
                      value="Invoice 1"
                    >
                      {languageHelper("Invoice 1")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 2"}
                      value="Invoice 2"
                    >
                      {languageHelper("Invoice 2")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 3"}
                      value="Invoice 3"
                    >
                      {languageHelper("Invoice 3")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 3 with VAT"}
                      value={"Invoice 3 with VAT"}
                    >
                      {languageHelper("Invoice 3 with VAT")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 3 with Tax"}
                      value={"Invoice 3 with Tax"}
                    >
                      {languageHelper("Invoice 3 with Tax")}
                    </option>
                    <option
                      selected={invoice.invoice === "Invoice 4"}
                      value="Invoice 4"
                    >
                      {languageHelper("Invoice 4")}
                    </option>
                  </select>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2   font-bold">
                  {languageHelper("Theme Design")}
                </span>
                <div className="mb-2 pt-0">
                  <select className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
                    <option
                      selected={theme.theme === "Default"}
                      value="Default"
                    >
                      {languageHelper("Default")}
                    </option>
                    <option
                      selected={theme.theme === "Theme 1"}
                      value="Theme 1"
                    >
                      {languageHelper("Theme 1")}
                    </option>
                    <option
                      selected={theme.theme === "Theme 2"}
                      value="Theme 2"
                    >
                      {languageHelper("Theme 2")}
                    </option>
                  </select>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Invoice Language")}
                </span>
                <div className="mb-2 pt-0">
                  <select
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="invoice_lang"
                    onChange={handleInvoiceSettingsChange}
                  >
                    <option
                      selected={invoice.invoice_lang === "Default"}
                      value="Default"
                    >
                      {languageHelper("Default")}
                    </option>
                    <option
                      selected={invoice.invoice_lang === "English"}
                      value="English"
                    >
                      {languageHelper("English")}
                    </option>
                    <option
                      selected={invoice.invoice_lang === "Arabic"}
                      value="Arabic"
                    >
                      {languageHelper("Arabic")}
                    </option>
                  </select>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2   font-bold">
                  {languageHelper("Invoice Footer")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="5"
                    type="text"
                    placeholder="Default"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    value={invoice.invoice_footer}
                    name="invoice_footer"
                    onChange={handleInvoiceSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  {languageHelper("Invoice Footer1")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="5"
                    type="text"
                    placeholder="Default"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={invoice.invoice_footer1}
                    name="invoice_footer1"
                    onChange={handleInvoiceSettingsChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  {languageHelper("Invoice Footer2")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="5"
                    type="text"
                    placeholder="Default"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    value={invoice.invoice_footer2}
                    name="invoice_footer2"
                    onChange={handleInvoiceSettingsChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Order Date")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="order_date"
                      id="Order"
                      value="yes"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.order_date === "yes"}
                    />
                    <label className="form-check-label pl-1 " htmlFor="Order">
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="order_date"
                      id="Order1"
                      value="no"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.order_date === "no"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="Order1">
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Statement Date")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="statement_date"
                      id="statement_date_yes"
                      value="yes"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.statement_date === "yes"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="statement_date_yes "
                    >
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="statement_date"
                      id="statement_date_no"
                      value="no"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.statement_date === "no"}
                    />
                    <label
                      className="form-check-label  pl-1"
                      htmlFor="statement_date_no "
                    >
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Print Date")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="print_date"
                      id="PrintYes"
                      value="yes"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.print_date === "yes"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="PrintYes"
                    >
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="print_date"
                      id="PrintNo"
                      value="no"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.print_date === "no"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="PrintNo">
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Round Off")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="round_off"
                      id="RoundYes"
                      value="yes"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.round_off === "yes"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="RoundYes"
                    >
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="round_off"
                      id="RoundNo"
                      value="no"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.round_off === "no"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="RoundNo">
                      {languageHelper("No")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="round_off"
                      id="RoundCat"
                      value="only_cat"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.round_off === "only_cat"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="RoundCat">
                      {languageHelper("Let Category Decide")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Invoice Item Name")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="name_lang"
                      id="nameEng"
                      value="en"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.name_lang === "en"}
                    />
                    <label className="form-check-label pl-1 " htmlFor="nameEng">
                      {languageHelper("English")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="name_lang"
                      id="nameAr"
                      value="ar"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.name_lang === "ar"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="nameAr">
                      {languageHelper("Arabic")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="name_lang"
                      id="nameBoth"
                      value="both"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.name_lang === "both"}
                    />
                    <label
                      className="form-check-label  pl-1"
                      htmlFor="nameBoth"
                    >
                      {languageHelper("Both")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Check Ingredients Stock")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="ingredient_count"
                      id="IngYes"
                      value="yes"
                      onChange={handleRestaurantSettingsChange}
                      checked={restaurant?.ingredient_count === "yes"}
                    />
                    <label className="form-check-label pl-1 " htmlFor="IngYes">
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="ingredient_count"
                      id="IngNo"
                      value="no"
                      onChange={handleRestaurantSettingsChange}
                      checked={restaurant?.ingredient_count === "no"}
                    />
                    <label className="form-check-label  pl-1" htmlFor="IngNo">
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  Select Printing Type
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="printing_type"
                      id="IngYes"
                      value="Item Wise"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.printing_type === "Item Wise"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="PrintingItem"
                    >
                      Item wise
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="printing_type"
                      id="PrintingCat"
                      value="Category Wise"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.printing_type === "Category Wise"}
                    />
                    <label
                      className="form-check-label  pl-1"
                      htmlFor="PrintingCat"
                    >
                      Category wise
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Reset Order Numbers")}
                </span>
                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="use_order_number"
                      id="useShiftTiming"
                      value="shiftTiming"
                      onChange={handleRestaurantSettingsChange}
                      checked={restaurant?.use_order_number === "shiftTiming"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="useShiftTiming"
                    >
                      {languageHelper("Use Shift Timing")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="use_order_number"
                      id="resetAfter1Day"
                      value="resetAfter1Day"
                      onChange={handleRestaurantSettingsChange}
                      checked={
                        restaurant?.use_order_number === "resetAfter1Day"
                      }
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="resetAfter1Day"
                    >
                      {languageHelper("Reset after 1 day")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <label htmlFor="">
                  <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                    {languageHelper("No of Invoices")}
                  </span>
                  <div className="mb-2 pt-0">
                    <input
                      type="text"
                      placeholder="1"
                      className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                      name="no_of_invoices"
                      value={invoice?.no_of_invoices}
                      onChange={handleInvoiceSettingsChange}
                    />
                  </div>
                </label>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("JSPM Print")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="jspm_print"
                      id="JSPMYes"
                      value="yes"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.jspm_print === "yes"}
                    />
                    <label className="form-check-label pl-1 " htmlFor="JSPMYes">
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="jspm_print"
                      id="JSPMNo"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.jspm_print === "no"}
                      value="no"
                    />
                    <label className="form-check-label  pl-1" htmlFor="JSPMNo">
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Zatca Enabled?")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="is_zatca"
                      id="zatcaYes"
                      value="yes"
                      onChange={handleRestaurantSettingsChange}
                      checked={printSetting.is_zatca === "yes"}
                    />
                    <label className="form-check-label pl-1 " htmlFor="zatcaYes">
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="is_zatca"
                      id="zatcaNo"
                      onChange={handleRestaurantSettingsChange}
                      checked={restaurant.is_zatca === "no"}
                      value="no"
                    />
                    <label className="form-check-label pl-1" htmlFor="zatcaNo">
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor=""></label>
              <label htmlFor="">
                <button
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="button"
                  onClick={() => setShowModal(true)}
                >
                  {languageHelper("Theme")}
                </button>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Sale Date & Time")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="sale_date_time"
                      id="SaleDateAuto"
                      value="auto"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.sale_date_time === "auto"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="SaleDateAuto"
                    >
                      {languageHelper("Auto")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="sale_date_time"
                      id="SaleDateManual"
                      value="manual"
                      onChange={handleInvoiceSettingsChange}
                      checked={invoice.sale_date_time === "manual"}
                    />
                    <label
                      className="form-check-label  pl-1"
                      htmlFor="SaleDateManual"
                    >
                      {languageHelper("Manual")}
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Received Amount")}
                </span>

                <div className="flex gap-x-10 text-d-bg-text">
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      className="form-check-input "
                      type="radio"
                      name="received_amount"
                      id="AndroidYes"
                      value="yes"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.received_amount === "yes"}
                    />
                    <label
                      className="form-check-label pl-1 "
                      htmlFor="AndroidYes"
                    >
                      {languageHelper("Yes")}
                    </label>
                  </div>
                  <div className="mb-2 pt-1 text-sm">
                    <input
                      type="radio"
                      name="received_amount"
                      id="AndroidNo"
                      value="no"
                      onChange={handlePrintereSettingsChange}
                      checked={printSetting.received_amount === "no"}
                    />
                    <label
                      className="form-check-label  pl-1"
                      htmlFor="AndroidNo"
                    >
                      {languageHelper("No")}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Logo")}
                </span>
                {logoSetting.logo_image_url && !logo && (
                  <img
                    className="w-36"
                    src={logoSetting.logo_image_url}
                    alt=""
                  />
                )}
                {logo && <img className="w-36" src={logo} alt="" />}
                <div className="w-full pt-5">
                  <div className="flex flex-row items-center">
                    <input
                      type="file"
                      id="logo-input"
                      onChange={(e) => {
                        setSelectedLogo(e.target.files[0].name);
                        setLogo(URL.createObjectURL(e.target.files[0]));
                        setLogoUpload(e.target.files[0]);
                      }}
                      hidden
                    />
                    <label
                      htmlFor="logo-input"
                      className="w-28 block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-d-bg cursor-pointer"
                    >
                      {languageHelper("Choose File")}
                    </label>
                    <label className="text-sm text-slate-500">
                      {selectedLogo}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Loader")}
                </span>
                {loaderSetting.loader_url && !loader && (
                  <img className="w-36" src={loaderSetting.loader_url} alt="" />
                )}
                {loader && <img className="w-36" src={loader} alt="" />}
                <div className="w-full pt-5">
                  <div className="flex flex-row items-center">
                    <input
                      type="file"
                      id="loader-input"
                      onChange={(e) => {
                        setSelectedLoader(e.target.files[0].name);
                        setLoader(URL.createObjectURL(e.target.files[0]));
                        setLoaderUpload(e.target.files[0]);
                      }}
                      hidden
                    />
                    <label
                      htmlFor="loader-input"
                      className="w-28 block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-d-bg cursor-pointer"
                    >
                      Choose File
                    </label>
                    <label className="text-sm text-slate-500">
                      {selectedLoader}
                    </label>
                  </div>
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Splash Image")}
                </span>
                {splashSetting.splash_url && !splash && (
                  <img className="w-36" src={splashSetting.splash_url} alt="" />
                )}
                {splash && <img className="w-36" src={splash} alt="" />}
                <div className="w-full pt-5">
                  <div className="flex flex-row items-center">
                    <input
                      type="file"
                      id="splash-input"
                      onChange={(e) => {
                        setSelectedSplash(e.target.files[0].name);
                        setSplash(URL.createObjectURL(e.target.files[0]));
                        setSplashUpload(e.target.files[0]);
                      }}
                      hidden
                    />
                    <label
                      htmlFor="splash-input"
                      className="w-28 block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-d-bg cursor-pointer"
                    >
                      Choose File
                    </label>
                    <label className="text-sm text-slate-500">
                      {selectedSplash}
                    </label>
                  </div>
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Update")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>

        {showModal && (
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-20 p-8"
            onClick={() => setShowModal(false)}
          >
            <div
              className="relative mx-auto my-auto max-w-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/*content*/}
              <form
                onSubmit={handleColorUpdate}
                className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto"
              >
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                  <h1 className="text-md text-d-bg-text">
                    {languageHelper("Theme Color")}
                  </h1>
                  <button
                    className="ml-auto float-right text-2xl"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="text-d-bg-text"> × </span>
                  </button>
                </div>

                <div className="flex items-center justify-between  p-3">
                  <button
                    className="bg-[#BF0303] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(cherryRed)}
                  >
                    {languageHelper("Cherry Red")}
                  </button>
                  <button
                    className="bg-[#EBC400] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(sunLight)}
                  >
                    {languageHelper("Sun Light")}
                  </button>
                  <button
                    className="bg-[#098398] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(aquaBlue)}
                  >
                    {languageHelper("Aqua Blue")}
                  </button>
                  <button
                    className="bg-[#A0A1A6] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(lightGray)}
                  >
                    {languageHelper("Light Gray")}
                  </button>
                  <button
                    className="bg-[#DD035A] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(lightPink)}
                  >
                    {languageHelper("Light Pink")}
                  </button>
                  <button
                    className="bg-[#074842] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => handlePresetColor(darkGreen)}
                  >
                    {languageHelper("Dark Green")}
                  </button>
                </div>

                <div>
                  <div className="p-3">
                    <h1 className="text-lg text-d-bg-text">
                      {languageHelper("Mobile Application Theme Color")}
                    </h1>
                  </div>

                  <div className="p-4 flex flex-wrap gap-6">
                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Background Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={colors.color_1}
                        name="color_1"
                        onChange={handleColorChange}
                        className=" relative 
                     rounded  border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Popup Buttons Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={colors.color_2}
                        name="color_2"
                        onChange={handleColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Background Text Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={colors.color_3}
                        name="color_3"
                        onChange={handleColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Text Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={colors.color_4}
                        name="color_4"
                        onChange={handleColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Categories Button Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={colors.color_5}
                        name="color_5"
                        onChange={handleColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div className="p-3">
                    <h1 className="text-lg text-d-bg-text">
                      {languageHelper("Theme Color For Webpage")}
                    </h1>
                  </div>

                  <div className="p-4 flex flex-wrap gap-6">
                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Background Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={webColors.color_1}
                        name="color_1"
                        onChange={handleWebColorChange}
                        className=" relative 
                     rounded  border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Headings Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={webColors.color_2}
                        name="color_2"
                        onChange={handleWebColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Button Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={webColors.color_3}
                        name="color_3"
                        onChange={handleWebColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Button Text Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={webColors.color_4}
                        name="color_4"
                        onChange={handleWebColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>

                    <div className="w-48">
                      <span className="text-d-bg-text text-md mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 ">
                        {languageHelper("Borders Color")}
                      </span>
                      <input
                        type="color"
                        placeholder="Select Item"
                        value={webColors.color_5}
                        name="color_5"
                        onChange={handleWebColorChange}
                        className=" relative rounded text-sm border-[#d2d6de] border w-full cursor-pointer p-2 h-9 bg-white "
                      />
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between  p-3">
                  <div>
                    <button
                      className="bg-d-cat-btn text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="button"
                      onClick={() => handlePresetColor(defaultColor)}
                    >
                      {languageHelper("Reset")}
                    </button>
                  </div>
                  <div className="flex items-center   p-3">
                    <button
                      className="text-d-bg-text text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      {languageHelper("Close")}
                    </button>
                    <button
                      className="bg-d-cat-btn text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                      type="submit"
                    >
                      {loading && (
                        <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                          <img
                            className="w-4 mx-auto"
                            src="https://i.gifer.com/ZKZx.gif"
                            alt=""
                          />
                        </span>
                      )}
                      {languageHelper("Update")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}

export default Setting;
